import { Box } from '@chakra-ui/react';
import React from 'react';
import desktop from '@/assets/questbet/images/banner/desktop.png';
import mobile from '@/assets/questbet/images/banner/mobile.png';
import Carousel from '@/components/Carousel';

export default function Index() {
  return (
    <Box
      sx={{
        mb: ['1', null, '1.5'],
      }}
    >
      <Carousel
        slides={[
          <Box
            key="banner-image"
            sx={{
              w: '100%',
              h: ['calc(100vh - 60vh)', null, '215px'],
              bgImage: [mobile, null, desktop],
              bgSize: '100% 100%',
              bgRepeat: 'no-repeat',
              borderBottom: '4px',
              borderColor: ['transparent', null, 'white'],
            }}
          />,
        ]}
      />
    </Box>
  );
}
